        // Purchase module option selector
        function selectOption(el, variantId) {
            document.querySelectorAll('.price-option').forEach(o => o.classList.remove('selected'));
            el.classList.add('selected');
            if (variantId) {
                var input = document.querySelector('.dynamic-variant-input');
                if (input) input.value = variantId;
            }
            syncPackPills();
        }
        // Bottom-CTA pack pills: real buttons that mirror the hero selector and pick its matching option
        // (Stefan 2026-10-13: equal cells, one selection shown in two places).
        function syncPackPills() {
            var sel = document.querySelector('.price-option.selected');
            var vid = sel ? String(sel.getAttribute('data-variant-id') || '') : '';
            document.querySelectorAll('.cta-price-pill[data-variant-id]').forEach(function (p) {
                var on = !!vid && p.getAttribute('data-variant-id') === vid;
                p.classList.toggle('active', on);
                p.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
        }
        document.addEventListener('click', function (e) {
            var p = e.target.closest && e.target.closest('.cta-price-pill[data-variant-id]');
            if (!p) return;
            var vid = p.getAttribute('data-variant-id');
            var opts = Array.prototype.slice.call(document.querySelectorAll('.price-option[data-variant-id="' + vid + '"]'));
            var opt = opts.filter(function (o) { return !o.hidden && !o.hasAttribute('hidden'); })[0] || opts[0];
            if (opt) selectOption(opt, vid);
        });
        syncPackPills();

        // Floating CTA pill: visible only when the hero "Pridať do košíka" CTA is offscreen.
        // Click on tablet/desktop scrolls to the top of the hero section so the bottle is fully visible
        // (mobile keeps the default href behavior of jumping straight to the purchase module).
        (function () {
            const heroCta = document.getElementById('heroCta');
            const fab = document.getElementById('floatingCta');
            if (!heroCta || !fab) return;
            new IntersectionObserver(([entry]) => {
                fab.classList.toggle('show', !entry.isIntersecting);
            }, { threshold: 0 }).observe(heroCta);
            fab.addEventListener('click', (e) => {
                if (window.innerWidth < 901) return;
                const purchase = document.getElementById('hero-purchase');
                if (!purchase) return;
                e.preventDefault();
                const purchaseHeight = purchase.offsetHeight;
                const viewportHeight = window.innerHeight;
                const purchaseTop = purchase.getBoundingClientRect().top + window.scrollY;
                let targetY;
                if (purchaseHeight < viewportHeight - 80) {
                    // Purchase module fits with breathing room - center it vertically
                    targetY = purchaseTop - (viewportHeight - purchaseHeight) / 2;
                } else {
                    // Module taller than viewport - anchor so "Pridať do košíka" button is in view (~80% down)
                    targetY = purchaseTop + purchaseHeight - viewportHeight + 60;
                }
                window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
            });
        })();

        // Extra -10 % badge tooltip: tap-to-toggle on touch devices
        const extraBadges = document.querySelectorAll('.extra-badge');
        extraBadges.forEach(b => {
            b.addEventListener('click', (e) => {
                if (e.target.closest('.extra-tip')) return;
                const wasOpen = b.classList.contains('open');
                extraBadges.forEach(o => o.classList.remove('open'));
                if (!wasOpen) b.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.extra-badge')) extraBadges.forEach(b => b.classList.remove('open'));
        });

        // Shipping pill tooltip: tap-to-toggle on touch devices
        const shipPills = document.querySelectorAll('.trust-item--ship');
        shipPills.forEach(p => {
            p.addEventListener('click', (e) => {
                if (e.target.closest('.ship-tip')) return;
                const wasOpen = p.classList.contains('open');
                shipPills.forEach(o => o.classList.remove('open'));
                if (!wasOpen) p.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.trust-item--ship')) shipPills.forEach(p => p.classList.remove('open'));
        });

        // Evidence-stat tooltip: tap-to-toggle on touch devices
        const evidenceStats = document.querySelectorAll('.evidence-stat');
        evidenceStats.forEach(s => {
            s.addEventListener('click', (e) => {
                if (e.target.closest('.evidence-tip')) return;
                const wasOpen = s.classList.contains('open');
                evidenceStats.forEach(o => o.classList.remove('open'));
                if (!wasOpen) s.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.evidence-stat')) evidenceStats.forEach(s => s.classList.remove('open'));
        });

        // FAQ accordion
        function toggleFaq(el) {
            const isActive = el.classList.contains('active');
            document.querySelectorAll('.faq-item').forEach(item => item.classList.remove('active'));
            if (!isActive) el.classList.add('active');
        }

        // GSAP Animations
        document.addEventListener('DOMContentLoaded', () => {
            gsap.registerPlugin(ScrollTrigger);

            gsap.from('.gsap-hero', { y: 40, opacity: 0, duration: 1, stagger: 0.15, ease: 'power3.out' });
            gsap.from('.gsap-hero-img', { x: 40, opacity: 0, duration: 1.2, ease: 'power3.out', delay: 0.3 });

            gsap.utils.toArray('.gsap-reveal').forEach(elem => {
                ScrollTrigger.create({
                    trigger: elem,
                    start: 'top 88%',
                    once: true,
                    onEnter: () => {
                        gsap.to(elem, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' });
                    }
                });
            });
        });


        // Floating ingredient pill - tap-to-toggle for touch devices
        const heroPills = document.querySelectorAll('.product-stage .pill');
        heroPills.forEach(p => {
            p.addEventListener('click', (e) => {
                if (e.target.closest('.pill-tip')) return;
                const wasOpen = p.classList.contains('open');
                heroPills.forEach(o => o.classList.remove('open'));
                if (!wasOpen) p.classList.add('open');
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.product-stage .pill')) {
                heroPills.forEach(p => p.classList.remove('open'));
            }
        });



        // Sticky PDP nav: glass-on-scroll
        (function () {
            var nav = document.getElementById('ip-pdp-nav');
            if (!nav) return;
            var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        })();
